<template>
    <section
        class="clients section reveal-fade"
        :class="[
            hasBgColor && 'has-bg-color',
            invertColor && 'invert-color'
        ]">
        <div class="container">
            <div
                class="clients-inner section-inner"
                :class="[
                    topDivider && 'has-top-divider',
                    bottomDivider && 'has-bottom-divider'
                ]">
                <ul class="list-reset">
                    <li>
                        <img :src="require('@/assets/images/clients-01.svg')" alt="Client 01" />
                    </li>
                    <li>
                        <img :src="require('@/assets/images/clients-02.svg')" alt="Client 02" />
                    </li>
                    <li>
                        <img :src="require('@/assets/images/clients-03.svg')" alt="Client 03" />
                    </li>
                    <li>
                        <img :src="require('@/assets/images/clients-04.svg')" alt="Client 04" />
                    </li>
                    <li>
                        <img :src="require('@/assets/images/clients-05.svg')" alt="Client 05" />
                    </li>
                </ul>
            </div>
        </div>
    </section>
</template>

<script>
import { SectionProps } from '@/utils/SectionProps.js'

export default {
  name: 'CClients',
  mixins: [SectionProps]
}
</script>